var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"realtimeframe"},[_c('div',{staticClass:"broadcast"},[_c('carousel',{attrs:{"data":_vm.data,"controls":false,"indicators":false,"interval":1500,"direction":"up"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }